var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Prop, Vue } from 'vue-property-decorator';
import ReclameAquiNumberOfComplaints from '@/modules/search/components/filterPanels/ComplaintsPanel/ReclameAquiNumberOfComplaints.vue';
import { connect } from '@/overmind';
import { json } from 'overmind';
let NumberOfComplaintsContainer = class NumberOfComplaintsContainer extends Vue {
    constructor() {
        super(...arguments);
        // @ts-ignore
        this.values = json(this.inputValues);
    }
    onValuesChanged(newVal) {
        this.values = newVal;
        // @ts-ignore
        this.actionsSearch.searches.buildPotentialResults();
        // @ts-ignore
        this.setInputRangeReclameAquiNumberOfComplaints(newVal);
    }
};
__decorate([
    Prop({ default: () => { } })
], NumberOfComplaintsContainer.prototype, "filter", void 0);
NumberOfComplaintsContainer = __decorate([
    Component(connect(({ state: { filters: state }, actions }) => ({
        selected: state.totalSelected.complaints.reclameAquiNumberOfComplaints,
        inputValues: state.selectedInputRange['reclamacoes_reclame_aqui.quantidade_reclamacoes'],
        setInputRangeReclameAquiNumberOfComplaints: actions.filters.setInputRangeReclameAquiNumberOfComplaints,
        actions: actions.filters,
        actionsSearch: actions.search,
    }), {
        components: { ReclameAquiNumberOfComplaints },
    }))
], NumberOfComplaintsContainer);
export default NumberOfComplaintsContainer;
